<template>
  <div>
    <top></top>
    <div class="contentWrapper">
            <span>
                <left></left>
            </span>
      <div class="right">
        <router-view></router-view>
      </div>

    </div>


  </div>
</template>

<script>
  import Left from './Left/Left'
  import Top from './Top/Top'
  import {eChart} from "../../../static/js/someCharts";

  export default {
    name: "Frame",
    components: {
      Left, Top
    },
    methods:{
    },
    mounted() {
      window.onresize = function () {
        for (let i in eChart.myChartArray) {
          eChart.myChartArray[i].resize()
        }
      }
      if (window.sessionStorage.getItem('isLogin') !== 'true') {
        this.$router.push({name: 'Login'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .contentWrapper {
    width: 100%;

    span {
      float: left;
    }

    .right {
      margin-left: 220px;
      height: calc(100vh - 50px);
      overflow: auto;
    }
  }
</style>
